export default __webpack_public_path__ + "static/media/20t.f358d5af.jpg";